import { render, staticRenderFns } from "./MyQuotesDetailsItem.vue?vue&type=template&id=dc0107f8&scoped=true&"
import script from "./MyQuotesDetailsItem.vue?vue&type=script&lang=js&"
export * from "./MyQuotesDetailsItem.vue?vue&type=script&lang=js&"
import style0 from "./MyQuotesDetailsItem.vue?vue&type=style&index=0&id=dc0107f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0107f8",
  null
  
)

export default component.exports